
import {
  defineComponent,
  ref,
  onBeforeMount,
  onMounted,
  watch,
  watchEffect,
} from "vue";
import Countdown from "vue3-countdown";
export default defineComponent({
  components: { Countdown },
  name: "CustomAudio",
  props: {
    musicUrl: String,
    meta: Object,
  },
  setup(props) {
    const audioPlayer = ref<HTMLVideoElement>();
    const countdown = ref();
    let audioStatus = ref(true);
    let audioTxt = ref("播放");
    let audioMusicUrl = ref(props.musicUrl);
    let audioTime = ref(0);
    const overAudio = () => {
      audioStatus.value = true;
      // countdown.value.reset();
      audioTxt.value = "播放";
    };
    const handlePause = () => {
      const player = audioPlayer.value;
      if (player) {
        console.log("当前时间:", player.currentTime);
        console.log("总时间:", player.duration);
        if (player.paused) {
          player.play();
          audioStatus.value = false;
          audioTxt.value = "暂停";
          // countdown.value.start();
        } else {
          player.pause();
          audioStatus.value = true;
          audioTxt.value = "播放";
          // countdown.value.stop();
        }
      }
    };

    const handleLoad = () => {
      // const player = audioPlayer.value;
      // audioTime.value = (player?.duration as number) * 1000;
      console.log("总时间1xxxxx:");
    };
    watch(
      audioTime,
      (newVal) => {
        console.log("watch:", newVal);
        audioTime.value = newVal;
        countdown.value.reset();
      },
      { flush: "post" }
    );

    onBeforeMount(() => {
      console.log("总时间1:", audioTime.value);
    });
    onMounted(() => {
      console.log("总时间2:", audioTime.value);
    });
    return {
      audioTime,
      audioPlayer,
      audioMusicUrl,
      audioStatus,
      audioTxt,
      countdown,
      overAudio,
      handlePause,
      handleLoad,
    };
  },
});
